export default (dispatch, props) => ({
  loadMore(next) {
    dispatch(props.fetchMoreAction(next)())
  }
})
